import Vue from 'vue';

export default {
  // Register mutations
  SET_REGISTERS(state, registers) {
    state.registers = registers;
  },

  SET_TOTAL(state, total) {
    state.total = total;
  },

  SET_SELECTED_REGISTER(state, register) {
    state.selectedRegister = register;
  },
  
  ADD_REGISTER(state, register) {
    state.registers.push(register);
  },
  
  UPDATE_REGISTER(state, updatedRegister) {
    const index = state.registers.findIndex(r => r.id === updatedRegister.id);
    if (index !== -1) {
      Vue.set(state.registers, index, updatedRegister);
    }
  },
  
  REMOVE_REGISTER(state, registerId) {
    state.registers = state.registers.filter(r => r.id !== registerId);
  },
  
  // Upload mutations
  SET_UPLOAD_PROGRESS(state, progress) {
    state.uploadProgress = progress;
  },
  
  SET_UPLOAD_STATUS(state, status) {
    state.uploadStatus = status;
  },
  
  SET_VALIDATION_RESULTS(state, results) {
    state.validationResults = results;
  },
  
  SET_IMPORT_RESULTS(state, results) {
    state.importResults = results;
  },
  
  // Template mutations
  SET_TEMPLATES(state, templates) {
    state.templates = templates;
  },

  ADD_TEMPLATE(state, template) {
    state.templates.push(template);
  },

  UPDATE_TEMPLATE(state, updatedTemplate) {
    const index = state.templates.findIndex(t => t.id === updatedTemplate.id);
    if (index !== -1) {
      Vue.set(state.templates, index, updatedTemplate);
    }
  },

  REMOVE_TEMPLATE(state, templateId) {
    state.templates = state.templates.filter(t => t.id !== templateId);
  },

  SET_CURRENT_MAPPING(state, mapping) {
    state.currentMapping = mapping;
  },
  
  // Facilities and Users
  SET_FACILITIES(state, facilities) {
    state.facilities = facilities;
  },
  
  SET_USERS(state, users) {
    state.users = users;
  },
  
  // UI mutations
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  
  SET_UPDATE_LOADING(state, loading) {
    state.updateLoading = loading;
  },
  
  SET_ERROR(state, error) {
    state.error = error;
  },
  
  CLEAR_ERROR(state) {
    state.error = null;
  },
  
  SET_OPTIONS(state, options) {
    state.options = { ...state.options, ...options };
  },

  // ==========================================
  // AUDIT LOG MUTATIONS
  // ==========================================

  SET_AUDIT_LOGS(state, logs) {
    state.auditLogs = logs;
  },

  SET_AUDIT_LOGS_TOTAL(state, total) {
    state.auditLogsTotal = total;
  },

  SET_AUDIT_LOGS_LOADING(state, loading) {
    state.auditLogsLoading = loading;
  },

  SET_AUDIT_LOG_DETAIL(state, detail) {
    state.auditLogDetail = detail;
  },

  SET_AUDIT_LOG_DETAIL_LOADING(state, loading) {
    state.auditLogDetailLoading = loading;
  },

  SET_AUDIT_SIDEBAR_OPEN(state, open) {
    state.auditSidebarOpen = open;
  },

  SET_AUDIT_SIDEBAR_MODE(state, mode) {
    state.auditSidebarMode = mode;
  },

  SET_AUDIT_REGISTER_ID(state, registerId) {
    state.auditRegisterId = registerId;
  },

  SET_SELECTED_ROW_FOR_AUDIT(state, row) {
    state.selectedRowForAudit = row;
  },

  SET_AUDIT_VIEW_MODE(state, mode) {
    state.auditViewMode = mode;
  },

  SET_AUDIT_FILTERS(state, filters) {
    state.auditFilters = { ...state.auditFilters, ...filters };
  },

  RESET_AUDIT_FILTERS(state) {
    state.auditFilters = {
      page: 1,
      itemsPerPage: 20,
      actionType: null,
      actionCategory: null,
      userId: null,
      fromDate: null,
      toDate: null,
      sortBy: 'actionTimestamp',
      sortDesc: true
    };
  },

  CLEAR_AUDIT_STATE(state) {
    state.auditLogs = [];
    state.auditLogsTotal = 0;
    state.auditLogDetail = null;
    state.auditRegisterId = null;
    state.selectedRowForAudit = null;
  },

  // ==========================================
  // API DATA SOURCE MUTATIONS
  // ==========================================

  SET_API_DATA_SOURCES(state, dataSources) {
    state.apiDataSources = dataSources;
  },

  SET_API_DATA_SOURCES_TOTAL(state, total) {
    state.apiDataSourcesTotal = total;
  },

  SET_SELECTED_API_DATA_SOURCE(state, dataSource) {
    state.selectedApiDataSource = dataSource;
  },

  SET_API_DATA_SOURCE_LOADING(state, loading) {
    state.apiDataSourceLoading = loading;
  },

  ADD_API_DATA_SOURCE(state, dataSource) {
    state.apiDataSources.push(dataSource);
  },

  UPDATE_API_DATA_SOURCE(state, updated) {
    const index = state.apiDataSources.findIndex(ds => ds.id === updated.id);
    if (index !== -1) {
      Vue.set(state.apiDataSources, index, updated);
    }
  },

  REMOVE_API_DATA_SOURCE(state, id) {
    state.apiDataSources = state.apiDataSources.filter(ds => ds.id !== id);
  },

  // API Wizard mutations
  SET_API_WIZARD_OPEN(state, open) {
    state.apiWizardOpen = open;
  },

  SET_API_WIZARD_STEP(state, step) {
    state.apiWizardStep = step;
  },

  SET_API_WIZARD_MODE(state, mode) {
    state.apiWizardMode = mode;
  },

  SET_API_WIZARD_CONFIG(state, config) {
    state.apiWizardConfig = { ...state.apiWizardConfig, ...config };
  },

  SET_API_WIZARD_TEST_RESULT(state, result) {
    state.apiWizardTestResult = result;
  },

  SET_API_WIZARD_PREVIEW_DATA(state, data) {
    state.apiWizardPreviewData = data;
  },

  SET_API_WIZARD_MAPPING(state, mapping) {
    state.apiWizardMapping = mapping;
  },

  SET_API_WIZARD_SCHEDULE(state, schedule) {
    state.apiWizardSchedule = { ...state.apiWizardSchedule, ...schedule };
  },

  RESET_API_WIZARD(state) {
    state.apiWizardStep = 1;
    state.apiWizardMode = 'create';
    state.apiWizardConfig = {
      name: '',
      url: '',
      httpMethod: 'GET',
      requestBody: '',
      headers: [],
      auth: {
        authType: 0,
        apiKeyHeaderName: '',
        apiKeyValue: '',
        bearerToken: '',
        username: '',
        password: '',
        tokenUrl: '',
        clientId: '',
        clientSecret: '',
        scope: '',
      },
      responseDataPath: '',
      pagination: {
        type: 0,
        pageParamName: 'page',
        pageSizeParamName: 'pageSize',
        pageSizeValue: 100,
        offsetParamName: 'offset',
        limitParamName: 'limit',
        limitValue: 100,
        cursorParamName: 'cursor',
        cursorResponsePath: '',
      },
    };
    state.apiWizardTestResult = null;
    state.apiWizardPreviewData = null;
    state.apiWizardMapping = null;
    state.apiWizardSchedule = {
      frequency: 0,
      hour: 0,
      minute: 0,
      dayOfWeek: 1,
      cronExpression: '',
      triggerImmediate: false,
    };
  },

  // Execution history mutations
  SET_EXECUTION_HISTORY(state, history) {
    state.executionHistory = history;
  },

  SET_EXECUTION_HISTORY_TOTAL(state, total) {
    state.executionHistoryTotal = total;
  },

  SET_EXECUTION_HISTORY_LOADING(state, loading) {
    state.executionHistoryLoading = loading;
  },
};